import { Button, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import InteractiveSvg from "../../../components/shared/InteractiveSvg/InteractiveSvg";
import { backBodySvg } from "../../../mock/interavticeSvgs/body/backBodySvg";
import { frontBodySvg } from "../../../mock/interavticeSvgs/body/frontBodySvg";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { setEditing } from "../../../redux/slices/entrySlice";
import { setBodyPartModalData } from "../../../redux/slices/generatorFeaturesSlice";
import { Flex } from "../../../styled";
import { type BodyPart } from "./BodyPart.model";
import BodyPartList from "./BodyPartList";

const BodyPartModal = () => {
  const dispatch = useDispatch();
  const { bodyPartModalData } = useSelector(
    state => state.generatorFeaturesSlice,
  );
  const { setValue } = useFormContext();
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedParts, setSelectedParts] = useState<BodyPart[]>([]);

  useEffect(() => {
    if (bodyPartModalData) {
      setSelectedParts(bodyPartModalData.value);
      open();
    } else close();
  }, [bodyPartModalData, close, open]);

  const handleClose = () => {
    dispatch(setBodyPartModalData(null));
  };
  const handleSave = () => {
    if (!bodyPartModalData) return;
    setValue(bodyPartModalData.inputId, selectedParts);
    dispatch(setEditing(true));
    handleClose();
  };
  return (
    <Modal
      title="Select body part"
      opened={opened}
      onClose={handleClose}
      size="60vw">
      <Text size="sm">Select body part by clicking it.</Text>
      <Text size="sm">Unselect target by clicking it again.</Text>
      <Flex gap={15} h="70vh" justify="center" mt={10}>
        <Flex direction="column" align="center" gap={10}>
          <Text size="xl">Front</Text>
          <Flex gap={5}>
            <div style={{ width: 120 }}>
              <BodyPartList
                type="front"
                bodyParts={selectedParts}
                setBodyParts={setSelectedParts}
                direction="column"
                clearable
              />
            </div>
            <InteractiveSvg
              svgFile={frontBodySvg}
              selectedParts={selectedParts}
              setSelectedParts={setSelectedParts}
              type="front"
            />
          </Flex>
        </Flex>
        <Flex direction="column" align="center" gap={10}>
          <Text size="xl">Back</Text>
          <Flex gap={5}>
            <InteractiveSvg
              svgFile={backBodySvg}
              selectedParts={selectedParts}
              setSelectedParts={setSelectedParts}
              type="back"
            />
            <div style={{ width: 120 }}>
              <BodyPartList
                type="back"
                bodyParts={selectedParts}
                setBodyParts={setSelectedParts}
                direction="column"
                clearable
              />
            </div>
          </Flex>
        </Flex>
      </Flex>
      <Flex justify="flex-end">
        <Button onClick={handleSave}>Save</Button>
      </Flex>
    </Modal>
  );
};
export default BodyPartModal;
